'use client';

import { useEffect } from 'react';

const SUFFIX = ' · supa.place';

/**
 * Sets `document.title` for client-rendered pages so the browser tab and
 * window title reflect the current view. App Router client components can't
 * export static `metadata`, so this is the lightweight equivalent for tab
 * labeling. Crawlers still see the default `<title>` from the root layout —
 * if SEO matters for a route, prefer a server component with `generateMetadata`.
 *
 * Pass `null` or an empty string to keep the existing title (useful while
 * data is still loading).
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (!title) return;
    const previous = document.title;
    const next = title.endsWith(SUFFIX) ? title : `${title}${SUFFIX}`;
    document.title = next;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
